/* ONNI Kategoriewechsel ohne Seitenladen (Ada, 01.08.2026, Auftrag Paavo)
 *
 * Warum ueberhaupt: Ein Klick auf eine Pill laedt heute die komplette Seite neu.
 * Gemessen am 01.08.: rund 9,7 MB und knapp 500 Anfragen, und zwar auch dann,
 * wenn sich nur zwei Kacheln aendern. Der Aufwand steckt im Theme und in den
 * Apps, nicht in den Produkten.
 *
 * Was dieses Skript macht: Es holt die Zielseite als HTML, tauscht daraus nur
 * die vier Bereiche aus, die sich wirklich unterscheiden, und schreibt die
 * Adresse per History API mit. Alle Skripte, Stile und Schriften bleiben im
 * Speicher, sie werden weder neu geladen noch neu ausgefuehrt.
 *
 * Bewusst NICHT nur Ein- und Ausblenden per JavaScript: Dann muessten
 * Produktzuordnung und Texte doppelt gepflegt werden, einmal in den Sammlungen
 * fuer Google und einmal hier. Das laeuft garantiert auseinander. So bleibt die
 * Sammlung die einzige Wahrheit, die echten URLs bleiben erhalten, und ohne
 * JavaScript funktionieren die Links ganz normal weiter.
 */
(function () {
  'use strict';

  // Bereiche, die beim Wechsel getauscht werden. Der Schluessel ist der Teil
  // hinter dem doppelten Unterstrich in der Section-ID; der bleibt gleich, auch
  // wenn die Vorlagen-Nummer sich unterscheidet.
  var BEREICHE = ['onni_pills_submenu', 'onni_collection_intro', 'main'];

  var container = document.querySelector('.onni-submenu-pills-container');
  if (!container || !window.history || !window.fetch || !window.DOMParser) return;

  var cache = {};
  var cacheReihe = []; // Reihenfolge fuer die Obergrenze, aelteste zuerst
  var CACHE_MAX = 3;
  var laeuft = null;
  // Welche Kategorie gerade wirklich auf dem Schirm steht.
  var angezeigt = window.location.pathname + window.location.search;

  function schluessel(el) {
    var m = (el.id || '').match(/^shopify-section-.*?__(.+)$/);
    return m ? m[1] : null;
  }

  function bereichsKnoten(wurzel) {
    var map = {};
    var alle = wurzel.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < alle.length; i++) {
      var k = schluessel(alle[i]);
      if (!k) continue;
      for (var j = 0; j < BEREICHE.length; j++) {
        if (k.indexOf(BEREICHE[j]) === 0) { map[BEREICHE[j]] = alle[i]; break; }
      }
    }
    return map;
  }

  function holen(url) {
    if (cache[url]) return cache[url];
    /* Nur die letzten drei Seiten merken (Code-Review D-12): je Collection
       rund 100 KB HTML, vorher ohne Obergrenze fuer die ganze Sitzung. */
    cacheReihe.push(url);
    while (cacheReihe.length > CACHE_MAX) delete cache[cacheReihe.shift()];
    cache[url] = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'onni-swap' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .catch(function (e) {
        delete cache[url];
        cacheReihe = cacheReihe.filter(function (u) { return u !== url; });
        throw e;
      });
    return cache[url];
  }

  /* Seitenaufruf an die Messung melden. Ohne das fehlt der View in GA4 und in
     den Pixeln, weil kein echter Seitenwechsel mehr stattfindet. */
  function aufrufMelden(url, titel) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_location: window.location.origin + url,
          page_title: titel,
          page_path: url
        });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'onni_virtual_pageview', page_path: url, page_title: titel });
      if (typeof window.fbq === 'function') window.fbq('track', 'PageView');
    } catch (e) { /* Messung darf den Wechsel nie blockieren */ }
  }

  function kopfAktualisieren(doc, url) {
    var t = doc.querySelector('title');
    if (t) document.title = t.textContent;
    var paare = [
      ['meta[name="description"]', 'content'],
      ['link[rel="canonical"]', 'href'],
      ['meta[property="og:title"]', 'content'],
      ['meta[property="og:description"]', 'content'],
      ['meta[property="og:url"]', 'content']
    ];
    for (var i = 0; i < paare.length; i++) {
      var neu = doc.querySelector(paare[i][0]);
      var ist = document.querySelector(paare[i][0]);
      if (neu && ist) ist.setAttribute(paare[i][1], neu.getAttribute(paare[i][1]));
    }
    return document.title;
  }

  function wechseln(url, ausHistorie) {
    if (laeuft === url) return;
    laeuft = url;
    document.documentElement.classList.add('onni-swap-laeuft');

    holen(url).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var neu = bereichsKnoten(doc);
      var ist = bereichsKnoten(document);

      var getauscht = 0;
      for (var i = 0; i < BEREICHE.length; i++) {
        var k = BEREICHE[i];
        if (neu[k] && ist[k]) {
          ist[k].replaceWith(neu[k]);
          getauscht++;
        }
      }
      if (!getauscht) { window.location.href = url; return; }

      /* Brotkrume steht seit 29.09.2026 im Layout unter dem Inhalt, in keiner
         Section. Sie muss eigens mit, sonst bleibt sie samt BreadcrumbList auf
         der Einstiegs-Kategorie stehen (Code-Review D-04). */
      var bcNeu = doc.querySelector('.onni-bc-unten');
      var bcIst = document.querySelector('.onni-bc-unten');
      if (bcNeu && bcIst) bcIst.replaceWith(bcNeu);
      else if (bcIst) bcIst.remove();
      else if (bcNeu && neu.main && neu.main.parentNode) neu.main.parentNode.appendChild(bcNeu);

      angezeigt = url;
      var titel = kopfAktualisieren(doc, url);
      if (!ausHistorie) window.history.pushState({ onniSwap: true }, '', url);
      nachObenSpringen();

      aktivePillSetzen();
      /* VIP-Preise der neuen Karten setzt der MutationObserver in discount.js.
         Das fruehere Neuladen von discount.js traf per Selektor Horizons
         cart-discount.js und warf bei jedem Wechsel einen JS-Fehler (D-01). */
      aufrufMelden(url, titel);
      binden();
      document.dispatchEvent(new CustomEvent('onni:collection-swapped', { detail: { url: url } }));
    }).catch(function () {
      // Im Zweifel immer der normale Seitenwechsel, nie eine tote Pill.
      window.location.href = url;
    }).then(function () {
      laeuft = null;
      document.documentElement.classList.remove('onni-swap-laeuft');
    });
  }

  /* Die aktive Pill markiert sonst niemand mehr.
     Im Normalfall macht das ein kleines Skript in der Sektion selbst, beim
     Seitenaufbau. Aus einem eingefuegten Knoten laeuft es nicht noch einmal,
     deshalb hier von Hand: gegen den PFAD vergleichen, nicht gegen den Link
     als Ganzes, sonst passt kein einziger. */
  function aktivePillSetzen() {
    var leiste = document.querySelector('.onni-submenu-pills-container');
    if (!leiste) return;
    var jetzt = window.location.pathname + window.location.search;
    var links = leiste.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var ziel = links[i].getAttribute('href') || '';
      links[i].classList.toggle('sub_pills_current', ziel === jetzt);
    }
    /* Die aktive Pille mittig in ihre Leiste ruecken.

       NICHT mit scrollIntoView (Befund 04.08.2026): Das scrollt die SEITE
       vertikal mit, sobald die Pille verdeckt ist — etwa vom Cookie-Banner
       beim ersten Besuch. Gemessen: ohne weggeklicktes Banner sprang die Seite
       auf 410 px, mit weggeklicktem Banner auf 0. Derselbe Klick, zwei
       Ergebnisse, und es sah aus wie ein Fehler im Sprung-Code.

       Deshalb von Hand nur die Leiste waagerecht scrollen. Damit kann die
       Seite gar nicht mehr vertikal wandern. */
    var aktiv = leiste.querySelector('a.sub_pills_current');
    if (aktiv && document.documentElement.clientWidth < 750) {
      var spur = aktiv.parentNode;
      while (spur && spur !== leiste && spur.scrollWidth <= spur.clientWidth) {
        spur = spur.parentNode;
      }
      if (spur && spur.scrollWidth > spur.clientWidth) {
        var mitte = aktiv.offsetLeft - (spur.clientWidth - aktiv.offsetWidth) / 2;
        spur.scrollTo({ left: Math.max(0, Math.round(mitte)), behavior: 'smooth' });
      }
    }
  }

  /* Nach dem Wechsel an den Anfang der Liste springen.
     Nicht auf 0: dort stehen erst Brotkrume und Einleitungstext, die Kacheln
     liegen unter der Bildkante — man saehe die neue Kategorie gar nicht.

     Bezugspunkt ist das Produktraster, NICHT die Pill-Leiste: Die klebt oben
     (position: sticky) und meldet im gescrollten Zustand ihre eigene, bereits
     verschobene Position. Genau daran ist der erste Versuch gescheitert, sie
     gab als Ziel den aktuellen Scrollstand zurueck und es passierte nichts.

     Vom Rasteranfang wird die Hoehe der klebenden Leiste abgezogen, damit sie
     nicht die erste Kachelreihe verdeckt.

     scroll-behavior steht im Theme auf smooth. Ein animierter Sprung ueber
     mehrere Bildschirme dauert und bricht ab, sobald jemand den Finger
     aufsetzt. Deshalb hier hart auf auto und danach zurueckgestellt. */
  /* KORREKTUR 02.08.2026 (Paavo, mit Videobeleg).

     Die Regel oben war zu schlicht: Es wurde IMMER zum Raster gesprungen, auch
     wenn die Kundin ganz oben stand und in Ruhe Ueberschrift und Einleitung
     lesen wollte. Fuer sie sah es aus, als springe die Seite grundlos weg.

     Richtig ist: Der Sprung soll nur den Zustand ERHALTEN, den sie schon hatte.
     War sie oben, bleibt die neue Seite oben. War sie unten bei den Produkten,
     landet sie wieder bei den Produkten.

     Gemessen wird der Stand VOR dem Klick — nach dem Wechsel ist er schon
     zurueckgesetzt. Die Schwelle von 80 px faengt kleine Wischer ab, die keine
     Absicht sind. */
  var standVorKlick = 0;

  function nachObenSpringen() {
    if (standVorKlick < 80) return;
    var raster = document.querySelector('results-list') ||
                 document.querySelector('.collection-wrapper') ||
                 document.querySelector('.onni-codev5');
    /* ONNI 09.09.2026: Die Hoehe der Pill-Leiste wird nicht mehr abgezogen. Das
       war noetig, solange sie oben klebte und sonst die erste Kachelreihe
       verdeckt haette. Seit sie mitscrollt, verdeckt sie nichts mehr. */
    var ziel = 0;
    if (raster) {
      ziel = raster.getBoundingClientRect().top + window.scrollY - 8;
    }
    var merk = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.max(0, Math.round(ziel)));
    document.documentElement.style.scrollBehavior = merk;
  }

  /* Vor dem Wechsel festhalten, wo die Kundin stand. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a');
    if (a) standVorKlick = window.scrollY || 0;
  }, true);

  function istIntern(a) {
    var href = a.getAttribute('href') || '';
    return href.indexOf('/collections/') === 0 && href.indexOf('#') !== 0;
  }

  function binden() {
    var leiste = document.querySelector('.onni-submenu-pills-container');
    if (!leiste || leiste.dataset.onniSwap === '1') return;
    leiste.dataset.onniSwap = '1';

    leiste.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a || !istIntern(a)) return;
      // Mittel- und Rechtsklick sowie Modifier bleiben dem Browser ueberlassen,
      // sonst geht "in neuem Tab oeffnen" verloren.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      wechseln(a.getAttribute('href'), false);
    });

    /* Vorladen nur bei echter Absicht (Code-Review D-12): beim Aufsetzen des
       Fingers bzw. Mausknopfs, oder wenn die Maus 100 ms auf einer Pille ruht.
       Vorher lud schon das Wischen durch die Leiste jede Kategorie. */
    var verweilen = null;
    function vorladen(e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (a && istIntern(a)) holen(a.getAttribute('href')).catch(function () {});
    }
    leiste.addEventListener('pointerdown', vorladen, { passive: true, capture: true });
    leiste.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(verweilen);
      verweilen = setTimeout(function () { vorladen(e); }, 100);
    }, { passive: true });
    leiste.addEventListener('pointerout', function () { clearTimeout(verweilen); }, { passive: true });
  }

  /* Zurueck bis zur Einstiegsseite (Befund F12, seit 02.08.): Deren Eintrag
     hatte keinen Status, popstate hat ihn deshalb ignoriert. Die Adresse
     wechselte, der Inhalt blieb auf der zuletzt gewaehlten Kategorie. */
  try {
    var st = window.history.state;
    if (!st || !st.onniSwap) {
      var markiert = {};
      if (st && typeof st === 'object') for (var s in st) markiert[s] = st[s];
      markiert.onniSwap = true;
      window.history.replaceState(markiert, '');
    }
  } catch (e) { /* ohne Markierung bleibt nur der alte Zustand */ }

  window.addEventListener('popstate', function (e) {
    var ziel = window.location.pathname + window.location.search;
    /* Gleiche Adresse = kein Kategoriewechsel. Passiert z. B. am Handy beim
       Schliessen des Warenkorbs: Horizon legt fuers Oeffnen einen eigenen
       Verlaufseintrag an und geht beim Schliessen per history.back() zurueck. */
    if (ziel === angezeigt) return;
    if (e.state && e.state.onniSwap) wechseln(ziel, true);
  });

  binden();
})();
